import InteractiveMessage from './InteractiveMessage';

export default InteractiveMessage;
